import { setNameRowStay } from "../setNameRowStay"

export const getStayRequiredFields = (
  index: number,
  isRequiredLocationPhoneNumber1: boolean,
) =>
  isRequiredLocationPhoneNumber1
    ? [
        `${setNameRowStay(index)}.locationPhoneNumber1`,
        `${setNameRowStay(index)}.emailAddress1`,
      ]
    : [`${setNameRowStay(index)}.emailAddress1`]
